import { getSumWithCurrency } from '@utils/formatters/d3Formatters';

import { IGetMotivationData, IGetMotivationGoal } from '@api/types';
import { IMotivationPrepared, IMotivationGoalPrepared } from './interfaces';

export const prepareGoalsMap = (
    goals: IGetMotivationData['goals'],
): IGetMotivationGoal['goalGmv'][] => goals.map(item => item.goalGmv);

const getPercentOfAll = (goalSum, currentSum) => {
    if (currentSum >= goalSum) return 100;
    return Number.parseInt(((currentSum / goalSum) * 100).toFixed(0), 10);
};

/**
 * Функция для расчёта прогресса мотивации
 * Флоу расчёта такой - Оборот / на цель * 100, получаем процент, оборота от цели.
 * В случае с целью 2, так как цель 2 конечное число, а у нас это % от остатка, то перед вычислениями нужно получить остаток по цели 2.
 * @param {number[]} goalsSum - состоит из Цели 1 и Цели 2, Цель 2 - это конечное значение мотивации.
 * @param {number} currentSum - Общий оборот, если оборот >= Цели 2, то прогресс закончен.
 * @returns {number[]} массив процентов.
 */
export const getProgressLine = (goalsSum: number[], currentSum: number): number[] => {
    if (currentSum <= goalsSum[0]) {
        return goalsSum.map((goalSum, index) =>
            index === 0 ? getPercentOfAll(goalSum, currentSum) : 0,
        );
    }

    let lastGoal = 0;

    return goalsSum.map((goalSum, index) => {
        const prevGoal = index === 0 ? 0 : lastGoal;
        if (currentSum <= prevGoal) {
            lastGoal = goalSum;
            return 0;
        }

        const result = getPercentOfAll(goalSum - prevGoal, currentSum - prevGoal);

        lastGoal = goalSum;

        return result;
    });
};

export const getProportionsOfLines = (goalsSum: number[], width: number): number[] => {
    let previousGoal = 0;

    return goalsSum.map(goalSum => {
        const segmentWidth = goalSum - previousGoal;
        previousGoal = goalSum;

        return getPercentOfAll(width, segmentWidth);
    });
};

export const prepareMotivationData = (data: IGetMotivationData): IMotivationPrepared => ({
    currentGmv: getSumWithCurrency(data.currentGmv, 'RUB'),
    goals: data.goals.map(
        goal =>
            /* eslint-disable no-param-reassign */
            Object.keys(goal).reduce((acc, key) => {
                if (key === 'goalGmv' || key === 'bonusAmount') {
                    acc[key] = getSumWithCurrency(goal[key], 'RUB');
                    return acc;
                }
                acc[key] = goal[key];
                return acc;
            }, {}),
        /* eslint-disable no-param-reassign */
    ) as
        | [IMotivationGoalPrepared, IMotivationGoalPrepared]
        | [IMotivationGoalPrepared, IMotivationGoalPrepared, IMotivationGoalPrepared],
});
